import { render, staticRenderFns } from "./YoutubeFrame.vue?vue&type=template&id=5233b367&scoped=true&"
import script from "./YoutubeFrame.vue?vue&type=script&lang=ts&"
export * from "./YoutubeFrame.vue?vue&type=script&lang=ts&"
import style0 from "./YoutubeFrame.vue?vue&type=style&index=0&id=5233b367&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5233b367",
  null
  
)

export default component.exports